<template>
  <div>
    <label v-for="option in field.values"
           class="mt-radio mt-radio-outline"
           v-show="!isValueHidden(option.label)"
    >
      {{ option.label }}
      <input :name="field.name"
             :data-vv-as="field.description.replace(/\./g, '')"
             type="radio"
             :id="option.name"
             :disabled="locked"
             :value="option.label"
             :checked="value === option.label"
             v-validate="{required: required && !field.hide}"
             @change="$emit('input', option.label)"
      />
      <!-- XXX: this span is required for custom checkbox to display icon -->
      <span></span>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: false,
    },
    field: {
      type: Object,
      required: true
    },
    required: {
      type: Boolean,
      default: false,
    },
    locked: {
      type: Boolean,
      default: false,
    },
    hiddenValues: {
      type: Array,
      default: false,
    }
  },

  emits: ['input'],

  setup(props) {
    // TODO: move to composable
    const isValueHidden = (value) => {
      if (props.hiddenValues) {
        return props.hiddenValues.some(h => {
          return h.field === props.field.name && value === h.value
        })
      }
      return false;
    }

    return {
      isValueHidden,
    }
  }
}
</script>

<style scoped lang="scss">
.mt-radio {
  display: block;
}
</style>



// WEBPACK FOOTER //
// RadioGroupRender.vue?2a01b4bb